import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import atmImg from "../../Assets/Projects/atm.png";
import visualCanvasImg from "../../Assets/Projects/visualCanvas.png";
import jarvisImg from "../../Assets/Projects/jarvis.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          {/* 1. Creative Portfolio */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Creative 3D & Motion Design Portfolio"
              description="This is the personal portfolio website of Ibrahim Ayyan, a passionate 3D animator, motion designer, and multimedia artist who transforms creative concepts into dynamic visual experiences. The site showcases his expertise in 3D animation, motion graphics, video production, visual effects, and scene modeling, highlighting a range of services designed to engage and inspire audiences. With a focus on compelling visuals and storytelling through motion, the portfolio reflects both technical skill and artistic creativity, supported by client testimonials and professional work samples."
              ghLink="https://github.com/Hassaancoded/modern-portfolio"
              demoLink="https://www.ibrahimayyan.info/" 
            />
          </Col>

          {/* 2. ASQ Creatives */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="ASQ creatives"
              description="ASQ Creatives is a full‑service digital creative agency dedicated to helping brands elevate their presence and achieve impactful results. The agency combines artistic vision with strategic innovation to deliver bespoke services in graphic design, video production, UI/UX design, animation, and digital marketing. With a passion for creativity and client success, ASQ Creatives transforms imaginative concepts into engaging visual experiences and tailored digital solutions that resonate with audiences and support business growth."
              ghLink="https://github.com/Hassaancoded/asq-1"
              demoLink="https://asqcreatives.com/"
            />
          </Col>

          {/* 3. qbuyvo */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="qbuyvo"
              description="The project demonstrates practical work in e‑commerce web design, UI layout, product listing integration, and responsive user interface elements. QBUYVO is an online retail platform offering a range of fashion and lifestyle products, including footwear, accessories, and apparel. The site features a modern shopping interface, product categories for men and women, and integrated user functions such as account management, wishlist, and shopping cart."
              demoLink="https://qbuyvo.com/"              
            />
          </Col>

          {/* 4. Contractor */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Interior Decoration & Construction Services"
              description="Gypsum & Decor is a professional interior decoration and construction service provider offering specialized solutions for residential and commercial spaces. The company focuses on transforming interiors with skilled decor, painting, plastering (gypsum work), tile installation, and electrical services, delivering aesthetically appealing and functional environments. With experienced craftsmen and a commitment to quality materials and workmanship, Gypsum & Decor aims to enhance living and work spaces with durable finishes, attention to detail, and timely project completion."
              ghLink="https://github.com/Hassaancoded/contractor"
              demoLink="https://www.gypsumanddecor.com/"
            />
          </Col>

          {/* 5. Real‑Time Face Recognition Attendance */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Real‑Time Face Recognition Attendance System"
              description="This is a Real‑Time Face Recognition Attendance System that leverages computer vision and machine learning to automatically identify and record attendance using a webcam or camera feed. The system captures facial data, processes it in real‑time, and accurately matches faces against a stored database, making attendance tracking fast, reliable, and automated. Designed for practical use in classrooms, offices, and events, the project demonstrates proficiency in face detection, image processing, and real‑time system implementation. It highlights skills in building intelligent systems that combine AI‑based recognition algorithms with real‑world functionality."
              ghLink="https://github.com/Hassaancoded/Real-Time-Face-Recognition-Attendance"
              // demoLink="https://blogs.soumya-jit.tech/"      
            />
          </Col>

          {/* 6. ATM Simulator */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={atmImg}
              isBlog={false}
              title="ATM simulator"
              description="A simple ATM simulator built using HTML, CSS, and JavaScript. This project allows users to check their balance, deposit money, and withdraw funds with a clean and interactive UI."
              ghLink="https://github.com/Hassaancoded/atm-simulator-web"
             // demoLink="#"
            />
          </Col>

          {/* 7. Visual Canvas */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={visualCanvasImg}
              isBlog={false}
              title="AI‑Enhanced Interactive Drawing Application"
              description="An interactive AI‑supported drawing application that enhances user creativity by combining intuitive canvas tools with intelligent visual assistance. Users can draw freely, manipulate shapes, and explore dynamic creative workflows supported by real‑time feedback and smart features. The project demonstrates hands‑on experience in building engaging user interfaces, integrating advanced graphical tools, and implementing responsive interactions. It highlights skills in frontend development, real-time rendering logic, and AI‑driven user interaction design."
              ghLink="https://github.com/Hassaancoded/visualcanvas-2"
             // demoLink="#"
            />
          </Col>

          {/* 8. Marvel JARVIS Assistant */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={jarvisImg}
              isBlog={false}
              title="Marvel JARVIS assitant"
              description="This project is a web‑based interactive AI assistant interface inspired by the concept of JARVIS from the Marvel universe. When users visit the site, they are greeted with an engaging welcome screen and a choice of superhero‑style voice assistant avatars, creating a futuristic and fun UI experience. The interface is designed to offer selectable voice modes and visually appealing themes, making interaction with the AI feel dynamic and immersive."
              ghLink="https://jarvis-ai-hassaan.netlify.app/features"
              demoLink="https://jarvis-ai-hassaan.netlify.app/"
            />
          </Col>

          {/* 9. Real-time Translator */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Real-time translator"
              description="A real-time AI translator built with Python and Tkinter that translates English text into local Pakistani languages including:

Urdu 🟢
Sindhi 🟡
Punjabi (Shahmukhi script) 🔵
Pashto 🟠
Balochi 🔴
This tool translates text live as you type using Google Translate, optimized for Urdu script rendering and smoother performance."
              ghLink="https://github.com/Hassaancoded/ai-real-time-translator"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;